import React from "react"
import { Button } from "@blueprintjs/core"
import { useTranslation } from "react-i18next"

const OpenFullScreenButton = ({
  onClick,
}: {
  onClick?: (event: React.MouseEvent) => void
}) => {
  const { t } = useTranslation()
  return (
    <div
      style={{
        position: "absolute",
        top: "105px",
        right: "10px",
        zIndex: 10,
      }}
    >
      <Button
        onClick={onClick}
        icon="fullscreen"
        className="dark:bg-gray-700 dark:text-white"
        title={t("maps.openFullScreen.title")}
      />
    </div>
  )
}

export default OpenFullScreenButton
